import { render } from "./Bin.vue?vue&type=template&id=fb9fee0a"
import script from "./Bin.vue?vue&type=script&lang=js"
export * from "./Bin.vue?vue&type=script&lang=js"

import "./Bin.vue?vue&type=style&index=0&id=fb9fee0a&lang=css"
script.render = render

export default script